import { UseFormReturn } from "react-hook-form";
import { Box, Typography } from "@mui/material";

import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";

import CheckboxInput from "@/components/RHFcomponents/CheckboxInput";
import CreditCardInputs from "@/components/RHFcomponents/PaymentInputs";
import { useState, useEffect } from "react";
import CheckBoxStep from "@/components/Checkout/GuestCheckout/steps/CheckBoxStep.tsx";

interface IProp {
  methods: UseFormReturn<ICheckoutForm, unknown, undefined>;
}

const FormThirdStep: React.FC<IProp> = ({
  methods: { control, watch },
}) => {
    const [checkboxInput, setCheckboxInput] = useState(true);
    const isUSAselected = watch().billingIdCountry === 1;

    const billingAddressValue = watch("billingAddress");

    useEffect(() => {
        setCheckboxInput(billingAddressValue);
    }, [billingAddressValue]);

  return (
    <>
      <Typography
        fontSize={{ xs: "1.125rem", md: "1.25rem" }}
        fontWeight={700}
        fontFamily={{ xs: FONT_PRIMARY, md: FONT_SECONDARY }}
        mb={3}
      >
        Provide card information
      </Typography>
      <Box display="flex" gap={{ xs: 2, md: 3 }} flexDirection="column" mb={3}>
        <CreditCardInputs control={control} />
      </Box>
        <CheckBoxStep
            checkboxInput={checkboxInput}
            isUSAselected={isUSAselected}
            control={control}
        />
        <CheckboxInput
            checked={checkboxInput}
            name="billingAddress"
            control={control}
            label="Use shipping address as billing address"
            onChange={setCheckboxInput}
      />
    </>
  );
};

export default FormThirdStep;
